export default async ({ store, redirect }) => {
  await store.dispatch('auth/logout');
  return redirect('/login');
};
